import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  item: VideoItem;
}

export default function VideoCard({ item }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative w-full h-44 overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - ${item.type}高清视频`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-background-950/70 px-2 py-0.5 text-xs font-medium text-background-50 backdrop-blur-sm">
          {item.category}
        </span>
        <span className="absolute right-3 top-3 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-medium text-background-50">
          {item.updateStatus}
        </span>
        <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between bg-gradient-to-t from-background-950/80 to-transparent px-3 pb-2 pt-6 text-xs text-background-50">
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {item.duration}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line" />
            {item.views}
          </span>
        </div>
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between gap-2">
          <h3 className="line-clamp-1 font-heading text-base font-semibold text-foreground-900 transition-colors group-hover:text-primary-600">
            {item.title}
          </h3>
          <span className="flex shrink-0 items-center gap-0.5 text-sm font-bold text-accent-600">
            <i className="ri-star-fill" />
            {item.rating}
          </span>
        </div>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{item.description}</p>
        <div className="mt-3 flex flex-wrap items-center gap-2 text-xs text-foreground-400">
          <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-secondary-800">{item.type}</span>
          <span>{item.region}</span>
          <span>{item.year}</span>
        </div>
      </div>
    </Link>
  );
}